import { ReduxState } from 'app/redux/types';

import { SignalrState } from './reducer';

// ---

export const selectSignalrState = (state: ReduxState): SignalrState | undefined => {
  return state.signalr;
};

export const selectSignalrConnected = (state: ReduxState): boolean | null => {
  return selectSignalrState(state)?.connected ?? null;
};
